module.exports = __webpack_public_path__ + "img/76_2.f5062af7.png";